module.exports = __webpack_public_path__ + "img/banner_bg.0ea011cf.png";